import * as types from '../mutation-types'

const state = {
  modes: JSON.parse(localStorage.getItem('product_modes'))
}

const mutations = {
  [types.PRODUCT_RESET_VALUES] (state) {
    let defaultValues = getDefaultValues()
    state.modes = defaultValues.modes
    localStorage.removeItem('product_modes')
  },
  [types.PRODUCT_SET_MODES] (state, modes) {
    state.modes = modes
    localStorage.setItem('product_modes', JSON.stringify(modes))
  }
}

function getDefaultValues () {
  return {
    modes: null
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/product.js